export const toggleProjectPriceAnalytics = ({ isToggledOn, pageType }) => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS.trigger(
      'project-estimate-overlay.toggle-project-price',
      { isToggledOn, pageType }
    );
  }
};

export const overlayAnalytics = () => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS.trigger('project-estimate-overlay.overlay');
  }
};